<template>
    <div>
       <h1>Redirecionado...</h1>
    </div>
</template>

<script>
import OctadeskComponent from '@/components/OctadeskComponent'
import TopoComponent from '@/components/TopoComponent'

export default {
  components: { OctadeskComponent, TopoComponent },
  props: ['clinicaid','empresa'],
  name: 'acesso-direcionado',
  created(){
    if(this.clinicaid != null){
        sessionStorage.setItem("clinica-direcionada", this.clinicaid)
    }
    location.href = '/passo1/'+this.empresa
  },
  data(){
    return {
        nomeempresa: null
    }
  }
}
</script>